import { Save } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useParams } from "react-router-dom";
import ToastContext from "../../../services/Context/ToastContext";
import { useContext } from "react";
import API from "../../../services/API";
import useStore from "./useStore";
import { txt } from "../../../services/translation";

export default function SaveButton(){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)

    const {orientation, picture, items, deselectItem, status, setStatus} = useStore()


    const handleClick = () => {

        deselectItem()

        setStatus('saving')

        const data = {orientation, picture, items}

        API.post(`/courses/${id}/certificate`, data)
            .then(r => {
                console.log(r.data)
                setToast({severity: 'success', message: txt('changesSavedSuccess')})
                setStatus('saved')
            })
            .catch(e => {
                console.error(e.response?.data)
                setToast({severity: 'error', message: txt('errorOccurred')})
                setStatus('changed')
            })
    }

    return (
        <LoadingButton 
            startIcon={<Save />} 
            onClick={handleClick}
            loading={status === 'saving'}
            disabled={status !== 'changed'}
            variant='outlined'
        >
            {txt('save')}
        </LoadingButton>
    )
}